import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7h76tk1dcp: FaireBrandEntity = {
  token: "b_7h76tk1dcp",
  type: "brand",
  name: "ALO drink",
  avatarUrl:
    "https://cdn.faire.com/fastly/a146d44129d751c4799b0a81c2a3ece4d1495f022865ceceac1592e449a494d3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a22c92319a0998cd39b3730111f1a3c97ba3b9cca7f9c0346813da011c2c760.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a146d44129d751c4799b0a81c2a3ece4d1495f022865ceceac1592e449a494d3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a22c92319a0998cd39b3730111f1a3c97ba3b9cca7f9c0346813da011c2c760.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 139,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "Great flavor comes from our dedication to using real aloe vera straight from the leaf harvested from sustainable farms in Thailand, and combining them with fruit and vegetable juices, and only the best Non-GMO or organic ingredients. It’s pure liquid harmony.\n\nAs a leader in the plant-based beverage category, we are proud of our entire lineup and our new organic products. We are creative with flavor combinations and hope to inspire your lifestyle.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:18.517Z",
    importedBy: "entity-db-cli",
  },
};
